type PublicRouteLayoutProps = {
  children: React.ReactNode;
};

export const PublicRouteLayout = ({ children }: PublicRouteLayoutProps) => {
  return <div className="main-container">{children}</div>;
};
